import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';

export const SideBarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #f3f1ea;
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '100%' : 0)};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

export const CloseIcon = styled(FaTimes)`
  color: #000;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`;

export const SideBarWrapper = styled.div`
  color: #000;
`;

export const SideBarMenu = styled.ul`
  display: grid;
  grid-template-colums: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`;

export const SideBarLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #000;
  text-decoration: none;
  list-style: none;
  transition: 0.2s easy-in-out;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    color: #f3f1ea;
    text-decoration: none;
    transition: 0.2s easy-in-out;
  }
`;

export const SideBtnWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SideBarRoute = styled(LinkR)`
  ${
    '' /* border-radius: 50px;
  background: #979692;
  white-space: nowrap;
  padding: 16px 64px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s easy-in-out;
  text-decoration: none;

  &:hover {
    background: #fff;
    transition: all 0.2s easy-in-out;
  } */
  }

  color: #979692;
  font-size: 1.5rem;
  outline: none;
  border: none;
  ${'' /* cursor: pointer; */}
  transition: all 0.2s easy-in-out;
  text-decoration: none;
  margin-left: 15px;
  &:hover {
    transition: all 0.2s easy-in-out;
    ${
      '' /* background: #fff;
        color: #010606; */
    }
  }

  ::after {
    content: 'Скоро';
    left: -15px;
    top: -10px;
    position: relative;
    padding: 1px 6px;
    border-radius: 8px;
    background-color: #dfbfb1;
    color: #000;
    font-size: 1rem;
    line-height: 22px;
  }
`;
